import React from 'react';
import { FaStar, FaStarHalfAlt } from 'react-icons/fa';

const DashboardRatingStars = ({ rating = 0 }) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    return (
        <div className="d-flex align-items-center">
            {[...Array(fullStars)].map((_, index) => (
                <FaStar key={index} className="text-warning me-1" size={12} />
            ))}
            {hasHalfStar ? <FaStarHalfAlt className="text-warning me-1" size={12} /> : null}
            <span className="text-muted ms-1">{rating}/5</span>
        </div>
    );
};

export default DashboardRatingStars;